import type { ReactNode } from 'react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  icon?: ReactNode;
  actions?: ReactNode;
}

export function PageHeader({ title, subtitle, icon, actions }: PageHeaderProps) {
  return (
    <div className="mb-6 flex-shrink-0 px-1">
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-4">
          {icon}
          <div>
            <h1 className="text-3xl font-bold text-foreground tracking-tight mb-1">{title}</h1>
            {subtitle && <p className="text-sm text-muted-foreground font-medium">{subtitle}</p>}
          </div>
        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
